import React, { useMemo } from 'react';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { AddProcurementType } from 'models/procurement.model';
import useDashboardContext from 'contexts/dashboard.context';
import { formatCurrency, unwrapAmount } from 'utils/functions';

const AddProcurementPreview = ({
  formData,
  handleEdit
}: {
  formData: AddProcurementType[];
  handleEdit: () => void;
}) => {
  const { formVendorsList } = useDashboardContext();
  const getVendorNameAndPrice = (id: string) => formVendorsList?.find((vendor) => vendor.id === id);

  const total = useMemo(() => {
    return formData.reduce((sum, request) => {
      const price = unwrapAmount(request.vendor_ingredient_price);
      const quantity = Number(request.quantity);
      return sum + price * quantity;
    }, 0);
  }, [formData]);

  return (
    <div>
      {formData.map((data, index) => (
        <div
          className='flex justify-between border-b border-b-[#EAEBEB] py-6 gap-6 items-center'
          key={index}>
          <div>
            <p className='font-medium text-[#2E3031] text-lg  capitalize'>{data.ingredient_name}</p>
            <div className='flex gap-2 flex-wrap'>
              <p className='text-sm font-medium text-[#2E3031]'>
                {data.quantity} {data.vendor_ingredient_unit_type} Requested
              </p>

              <div className='flex items-center gap-1'>
                <div className='bg-[#DCDBD5] w-[5px] h-[5px] rounded-full' />
                <p className='text-[#6F7376] text-sm font-medium'>
                  {getVendorNameAndPrice(data.vendor_id)?.name || 'No vendor'}
                </p>
                <div className='bg-[#DCDBD5] w-[5px] h-[5px] rounded-full' />
                <p className='text-[#6F7376] text-sm font-medium'>
                  {formatCurrency(
                    Number(data.vendor_ingredient_price.replace(/[₦,\s]/g, '')) *
                      Number(data.quantity)
                  )}
                </p>
              </div>
            </div>
          </div>
          <EditIcon onClick={handleEdit} className='cursor-pointer' />
        </div>
      ))}
      <div className='flex justify-end gap-4 mt-6 items-center mb-[40px]'>
        <p className='text-sm text-[#6F7376]'>Total</p>
        <h4 className='text-[#2E3031] text-2xl font-semibold'>₦ {total.toLocaleString()}</h4>
      </div>
    </div>
  );
};

export default AddProcurementPreview;
